<template>
    <div>
        <b-row>
            <b-col md="3" class="text-center" v-for="user in users" :key="user.id">
                <b-card :title="user.name"
                        :img-src="setMainPathImage(user)"
                        img-alt="Image"
                        img-top
                        tag="article"
                        class="mb-2">
                    <p class="card-text">
                        <strong>Saldo actual:</strong> {{user.saldo}} <br>
                        <strong>Limite de compras diarias:</strong> {{user.saldo > 0 ? user.saldo : 'Sin restriccion' }} <br>
                        <strong>Productos bloqueados:</strong> {{user.countproducts}}
                    </p>
                    <b-button variant="primary" @click="gotToLocks(user)" block>Ver restriscciones</b-button>
                </b-card>
            </b-col>
        </b-row>
    </div>
</template>

<script>
export default {
  name: "students_locks",
  data() {
    return {
      users: []
    };
  },
  created() {
    this.getStudents();
  },
  methods: {
    setMainPathImage(element) {
      let mainPath = localStorage.getItem("urlApi");
      mainPath = mainPath.replace("/api", "");
      let img = mainPath + element.url;
      return img;
    },
    getStudents() {
      this.$store
        .dispatch("academicBlockStudentList")
        .then(response => {
          this.users = this.$store.getters.academicBlockProducts;
        })
        .catch(error => {});
    },
    gotToLocks(item) {
      this.$router.push("/academic/locks/create/" + item.code);
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/modules/academic/block_products/list.vue